//src/api/examMasterListApi.js
import axiosInstance from './axiosInstance'; 

export const fetchExamMasterList = async () => {
  const response = await axiosInstance.get('/exams/');
  return response.data;
};